import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import axiosClient from '../../api/axiosClient';
import { Bell, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UserNotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // Fetch Tickets waiting for User Reply
  const { data: tickets = [] } = useQuery({
    queryKey: ['userNotifications'],
    queryFn: async () => {
        try {
            const res = await axiosClient.get('/support/tickets');
            // Filter only tickets where Staff replied
            return (Array.isArray(res) ? res : []).filter(t => t.status === 'awaiting_reply');
        } catch { return []; }
    },
    refetchInterval: 10000
  });

  const unreadCount = tickets.length;

  return (
    <div className="relative">
      <button 
        className="p-2.5 rounded-full hover:bg-slate-100 text-slate-600 transition-colors relative"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Bell className="w-5 h-5" />
        {unreadCount > 0 && (
          <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border border-white animate-pulse"></span>
        )}
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)}></div>
          <div className="absolute right-0 mt-3 w-80 bg-white rounded-xl shadow-xl border border-slate-100 z-20 overflow-hidden animate-in fade-in zoom-in-95 origin-top-right">
            <div className="p-4 border-b border-slate-50 bg-slate-50/50">
              <h3 className="font-semibold text-slate-800 text-sm">Notifications</h3>
            </div>
            
            <div className="max-h-80 overflow-y-auto">
              {tickets.length === 0 ? (
                <div className="p-8 text-center text-slate-400 text-sm">No new notifications</div>
              ) : (
                tickets.map((t) => (
                  <div 
                    key={t.ticket_uid} 
                    className="p-4 border-b border-slate-50 hover:bg-blue-50 cursor-pointer transition-colors"
                    onClick={() => { navigate('/portal/tickets'); setIsOpen(false); }}
                  >
                    <div className="flex items-start space-x-3">
                      <div className="p-2 rounded-lg bg-blue-100 text-blue-600 mt-0.5">
                        <MessageSquare className="w-4 h-4" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-slate-800">New Reply on Ticket</p>
                        <p className="text-xs text-slate-500 mt-0.5">#{t.ticket_uid}: {t.subject}</p>
                        <p className="text-[10px] text-blue-600 font-bold mt-1">Action Required</p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserNotificationDropdown;